import { useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import MyPackages from "./myPackages";
import SubscribedPackages from "./subscribedPackages";


export default function SignalPackagesTabs() {

    const [activeTab, setActiveTab] = useState("myPackages");
    const navigate = useNavigate();

    return (

        <div className="flex flex-col pt-24 gap-6">
            <div>
                <header className="fixed top-0 left-0 right-0 shadow-sm z-50 bg-white px-5 py-4 flex items-center justify-between border-b border-gray-100">
                    <button
                        onClick={() => navigate("/profile")}
                        className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors"
                    >
                        <FaArrowLeft className="text-gray-600" />
                    </button>
                    <div className="text-center">
                        <h1 className="text-lg font-bold text-gray-900">Signal Packages</h1>
                    </div>
                    <div className="w-10"></div>
                </header>
            </div>

            {/* Tabs */}
            <div
                id="packages-tab"
                className="bg-white p-1 rounded-xl flex gap-2 items-center justify-around shadow-sm"
            >
                {/* دکمه اول */}
                <button
                    onClick={() => setActiveTab("myPackages")}
                    className={`w-full text-center py-2 rounded-xl font-semibold transition-all duration-300 ${activeTab === "myPackages"
                        ? "bg-gradient-to-r from-[#7c90e9] to-[#8B9FEB] text-white shadow-md"
                        : "text-slate-600 hover:bg-slate-50"
                        }`}
                >
                    MY PACKAGES
                </button>

                {/* دکمه دوم */}
                <button
                    onClick={() => setActiveTab("subscribedPackages")}
                    className={`w-full text-center py-2 rounded-xl font-semibold transition-all duration-300 ${activeTab === "subscribedPackages"
                        ? "bg-gradient-to-r from-[#7c90e9] to-[#8B9FEB] text-white shadow-md"
                        : "text-slate-600 hover:bg-slate-50"
                        }`}
                >
                    SUBSCRIBED PACKAGES
                </button>
            </div>

            {/* Tab Content */}
            <div>
                {activeTab === "myPackages" && (
                    <MyPackages />
                )}

                {activeTab === "subscribedPackages" && (
                    <SubscribedPackages />
                )}
            </div>

        </div>
    )
}